import useAgronomistList from 'hooks/useAgronomistList';
import { useState } from 'react';

export enum CollectionStatus {
  'LATE' = 'Late',
  'LIVE' = 'Live',
  'SETTLED' = 'Settled',
}

const collectionStatusFilterOptions = Object.values(CollectionStatus)?.map(
  (status) => ({
    value: status,
    label: status,
  }),
);

const useCashTableFilters = (country: string) => {
  const [searchedInvoice, setSearchedInvoice] = useState<string>();
  const [invoice, setInvoice] = useState<string | null>(null);
  const [collectionStatus, setCollectionStatus] =
    useState<CollectionStatus | null>(null);
  const [agronomist, setAgronomist] = useState<any[]>([]);
  const [farmers, setFarmers] = useState<string[]>([]);

  const { isLoading: isAgronomistListLoading, agronomistFilterOptions } =
    useAgronomistList(country);

  const resetTableFilters = () => {
    setCollectionStatus(null);
    setAgronomist([]);
    setFarmers([]);
    setSearchedInvoice(undefined);
  };

  return {
    currentCollectionStatus: collectionStatus,
    setCurrentCollectionStatus: setCollectionStatus,
    collectionStatusFilterOptions,
    currentAgronomist: agronomist,
    setCurrentAgronomist: setAgronomist,
    agronomistFilterOptions,
    isAgronomistListLoading,
    currentSearchedInvoice: searchedInvoice,
    setCurrentSearchedInvoice: setSearchedInvoice,
    currentInvoice: invoice,
    setCurrentInvoice: setInvoice,
    currentFarmer: farmers,
    setCurrentFarmer: setFarmers,
    resetTableFilters,
  };
};

export default useCashTableFilters;
